import { computed, toValue, watch, type MaybeRefOrGetter } from 'vue';

import { useUserAccountsStore } from './user-accounts.store';

export const useAccountBankDetails = (accountId: MaybeRefOrGetter<string | null | undefined>) => {
  const userAccountsStore = useUserAccountsStore();
  const resolvedAccountId = computed(() => toValue(accountId) ?? null);
  const activeAccountId = computed(() => {
    const id = resolvedAccountId.value;
    if (!id) return null;

    const userAccount = userAccountsStore.accounts.find((account) => account.id === id);
    if (!userAccount) return null;
    if (userAccount.status !== 'active') return null;

    return id;
  });

  watch(
    activeAccountId,
    (id) => {
      if (!id) return;

      void userAccountsStore.ensureAccountDepositInformation(id);
    },
    { immediate: true },
  );

  return computed(() => {
    return userAccountsStore.getAccountBankDetails(resolvedAccountId.value ?? undefined);
  });
};
